import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

const RefreshTokenExpiringDialog = ({ open, minutesLeft, onConfirm }) => {
  const displayMinutes = minutesLeft ?? 5;
  const timeLabel =
    displayMinutes === 1 ? "1 minute" : `${displayMinutes} minutes`;

  return (
    <Dialog
      open={open}
      maxWidth='xs'
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgba(255, 167, 38, 0.3)",
        },
      }}
    >
      <DialogTitle
        sx={{
          pt: 4,
          pb: 1,
          display: "flex",
          alignItems: "center",
          gap: 2,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 167, 38, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
          }}
        >
          <WarningIcon sx={{ fontSize: 32, color: "warning.main" }} />
        </Box>

        <Typography
          variant='h5'
          component='div'
          sx={{
            fontWeight: 700,
            color: "text.primary",
            textAlign: "center",
            letterSpacing: "-0.01em",
          }}
        >
          Session Expiring Soon
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 0,
          pb: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant='body1'
          color='text.secondary'
          sx={{
            lineHeight: 1.7,
            fontSize: "0.95rem",
            maxWidth: "90%",
            mx: "auto",
          }}
        >
          Your session will expire in
          <br />
          <Box
            component='span'
            sx={{
              color: "warning.main",
              fontSize: "1.25rem",
              fontWeight: 700,
              display: "inline-block",
              my: 0.5,
            }}
          >
            {timeLabel}
          </Box>
          .
          <br />
          Please save your work to avoid data loss.
          <br />
          <Box
            component='span'
            sx={{
              color: "text.primary",
              fontWeight: 500,
            }}
          >
            You will be asked to sign in again to continue.
          </Box>
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          justifyContent: "center",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Button
          onClick={onConfirm}
          variant='contained'
          fullWidth
          size='large'
          sx={{
            color: "white",
            backgroundColor: "warning.main",
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "1rem",
            py: 1.5,
            "&:hover": {
              boxShadow: "0px 6px 16px rgba(255, 167, 38, 0.4)",
              backgroundColor: "warning.dark",
            },
          }}
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshTokenExpiringDialog;
